import React, { useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PropTypes from "prop-types";

import IconsPricingTableDesktop from "./IconsPricingTableDesktop";
import IconsPricingTableMobile from "./IconsPricingTableMobile";

import {
    IconsPricingTableContainer,
    IconsPricingTableButtonGroup
} from "./styles";

import { SHOW_DESKTOP_TABLE_MIN_SCREEN_WIDTH } from "./data";

const IconsPricingTable = ({ bestValueHighlight, eduPricingLayout }) => {
    const [planType, setPlanType] = useState("yearly");
    const showMonthlyPlanTable = () => setPlanType("monthly");
    const showYearlyPlanTable = () => setPlanType("yearly");

    const showDesktopTable = useMediaQuery(
        `(min-width: ${SHOW_DESKTOP_TABLE_MIN_SCREEN_WIDTH})`
    );
    const table = showDesktopTable ? (
        <IconsPricingTableDesktop
            planType={planType}
            bestValueHighlight={bestValueHighlight}
            eduPricingLayout={eduPricingLayout}
        />
    ) : (
        <IconsPricingTableMobile
            planType={planType}
            bestValueHighlight={bestValueHighlight}
            eduPricingLayout={eduPricingLayout}
        />
    );

    return (
        <IconsPricingTableContainer>
            <IconsPricingTableButtonGroup
                buttons={
                    eduPricingLayout
                        ? []
                        : [
                              {
                                  label: "Yearly Icon Plans",
                                  isActive: planType === "yearly",
                                  onClick: showYearlyPlanTable
                              },
                              {
                                  label: "Monthly Icon Plans",
                                  isActive: planType === "monthly",
                                  onClick: showMonthlyPlanTable
                              }
                          ]
                }
            />

            {table}
        </IconsPricingTableContainer>
    );
};

IconsPricingTable.propTypes = {
    bestValueHighlight: PropTypes.string, // this determines which column to highlight blue
    eduPricingLayout: PropTypes.bool // used for special styling when on EDU LP
};

export default IconsPricingTable;
